import httpClient from './httpClient'

const END_POINT = '/api/grupos'

const getByCurso = (idCurso,page,idLocalizacion) => httpClient.get(END_POINT, { params: { curso: idCurso, page: page, localizacion: idLocalizacion, pagination: false } })

export {

    getByCurso

}